import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import SymptomSelector from '../../../Symptom/SymptomSelector';
import { useApiClient } from '../../../../context/ApiClientContext';

function AddSymptomToNarrativeForm(props) {
  const { actionListId, onSuccess } = props;

  const apiClient = useApiClient();

  return (
    <Grid container>
      <Grid item xs={6}>
        <SymptomSelector
          handleSymptomAdd={(symptomId) => apiClient.addSymptomToNarrative(actionListId, symptomId)}
          buttonText="Add"
          successMsg="Symptom added to narrative successfully!"
          onSuccess={onSuccess}
        />
      </Grid>
    </Grid>
  );
}

AddSymptomToNarrativeForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AddSymptomToNarrativeForm;
